export default __webpack_public_path__ + "static/media/sd.1c2608a2.jpg";